import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { ResponseCode } from '@services/responseCode';
import {
  setWelcomeSelectedServeType,
  setWelcomeSelectedTakeoutServeType,
  setWelcomeSelectedServeTypeValid,
  setWelcomeIsCustomerPhoneValid,
  setWelcomeIsCustomerNameValid,
  setWelcomeIsCustomerAddressValid,
  setWelcomeIsShareMealValid,
  setWelcomePreorderTimeValid,
} from '@/actions/customizeWelcome/customizeWelcomeAction';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import ServeTypeUtils from '@/components/customizeWelcome/utils/serveTypeUtils';
import formatServiceSuspended from '@/utils/ServiceSuspendedUtils/formatServiceSuspended';
import formatResObject from '@/utils/ServiceSuspendedUtils/formatResObject';
import ServeTypeRow from './components/serveTypeRow';
import WelcomeForm from './components/welcomeForm';

function ServeTypeLayout({ webStoreVo, orderVo }) {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [selectedServeType, setSelectedServeType] = useState<string>('DEFAULT');
  const [selectedTakeOutServeType, setSelectedTakeOutServeType] =
    useState<string>('DEFAULT');
  const customizeWelcomeReducer = useSelector(
    (state: RootStateOrAny) => state.customizeWelcomeReducer
  );

  const resetWarnWordingStatus = () => {
    dispatch(setWelcomeSelectedServeTypeValid(true));
    if (isEmpty(customizeWelcomeReducer?.customerPhone))
      dispatch(setWelcomeIsCustomerPhoneValid(true));
    dispatch(setWelcomeIsCustomerNameValid(true));
    dispatch(setWelcomeIsCustomerAddressValid(true));
    dispatch(setWelcomeIsShareMealValid(true));
    dispatch(setWelcomePreorderTimeValid(true));
  };

  useEffect(() => {
    dispatch(setWelcomeSelectedServeType(selectedServeType));
    resetWarnWordingStatus();
  }, [selectedServeType]);

  useEffect(() => {
    dispatch(setWelcomeSelectedTakeoutServeType(selectedTakeOutServeType));
    resetWarnWordingStatus();
  }, [selectedTakeOutServeType]);

  return (
    <div>
      {/* 服務類型row */}
      <ServeTypeRow
        webStoreVo={webStoreVo}
        selectedServeType={selectedServeType}
        setSelectedServeType={setSelectedServeType}
      />
      {/* 訂單資料輸入 */}
      {webStoreVo.code !== ResponseCode.STORE_OFF_LINE &&
      !isEmpty(ServeTypeUtils.checkStoreServeTypeConfig(webStoreVo)) ? (
        <WelcomeForm
          webStoreVo={webStoreVo}
          orderVo={orderVo}
          selectedServeType={selectedServeType}
          selectedTakeOutServeType={selectedTakeOutServeType}
          setSelectedTakeOutServeType={setSelectedTakeOutServeType}
        />
      ) : (
        <div
          className="d-flex align-items-center justify-content-center rounded"
          style={{ backgroundColor: '#F5F8F9', padding: '32px 46px' }}
        >
          <div>
            <div
              className="d-flex justify-content-center fw-bolder"
              style={{ fontSize: '20px', color: '#000', textAlign: 'center' }}
            >
              {/* <FormattedMessage id="welcome.machine.offline" /> */}
              {formatServiceSuspended(intl, formatResObject(webStoreVo))}
            </div>

            <div
              className="d-flex justify-content-center mt-2"
              style={{
                fontSize: '16px',
                color: '#8D8C8C',
                textAlign: 'center',
              }}
            >
              <FormattedMessage id="welcome.machine.offline.msg" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

ServeTypeLayout.defaultProps = {};

ServeTypeLayout.propTypes = {
  webStoreVo: PropTypes.shape({
    availableServeTypes: PropTypes.arrayOf(PropTypes.string),
    availableTakeOutServeTypes: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  orderVo: PropTypes.shape({}).isRequired,
};

export default ServeTypeLayout;
